import getLocal from '@/app/utils/getLocal';
import { useReferralDispatch, useReferralStore } from '@/components/Referral/ReferralProvider';
import { useGlobal } from '@/utils/useGlobal';
import getDefaultHeader from 'lowcode/utils/service/getDefaultHeader';
import { getHostApi } from 'lowcode/utils/service/getHostApi';
import { useEffect, useRef } from 'react';

// us/ca 活动时间设定 2024/7/1 15:00PM - 2024/7/22 14:59PM
export const activity = {
    start: new Date('2024/7/01 15:00:00 GMT+8').getTime(),
    end: new Date('2024/7/22 14:59:00 GMT+8').getTime(),
};

const CountDown = () => {
    const dispatch = useReferralDispatch();
    const { actStatus } = useReferralStore();

    const { getSystemTime } = useGlobal();
    const { locale } = getLocal();
    const timer = useRef<NodeJS.Timeout | null>(null);
    const serverTime = useRef(getSystemTime());
    const clientTime = useRef(new Date().getTime());

    const handleVisibleChange = () => {
        if (window.document.visibilityState === 'visible') {
            getServiceTime();
        }
    };

    const getServiceTime = async () => {
        const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
        const headers: any = getDefaultHeader(locale);

        try {
            const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                headers,
            });
            const { data } = await spuData.json();
            serverTime.current = data?.timestamp;
        } catch (e) {
            console.log(e);
            serverTime.current = getSystemTime();
        }
    };

    const handleTimeOut = async () => {
        const nowTime = new Date().getTime();
        const intervalTime = nowTime - clientTime.current;
        // 倒计时执行间隔超过2s
        if (intervalTime > 2000) {
            await getServiceTime();
        } else {
            serverTime.current += intervalTime;
        }
        // 当前阶段
        let status = null;
        if (serverTime.current > activity.start && serverTime.current < activity.end) {
            status = 1;
        } else if (serverTime.current < activity.start) {
            status = -1;
            timer.current && clearTimeout(timer.current);
        } else if (serverTime.current > activity.end) {
            status = 0;
            timer.current && clearTimeout(timer.current);
        }

        if (status !== actStatus) {
            dispatch({
                type: 'changeIsActivity',
                payload: status,
            });
        }
        clientTime.current = nowTime;
        timer.current = setTimeout(handleTimeOut, 1000);
    };

    useEffect(() => {
        // 倒计时部分
        timer.current = setTimeout(handleTimeOut, 1000);
        // visiblity部分
        window.document.addEventListener('visibilitychange', handleVisibleChange);
        return () => {
            timer.current && clearTimeout(timer.current);
            window.document.removeEventListener('visibilitychange', handleVisibleChange);
        };
    }, []);

    useEffect(() => {
        timer.current && clearTimeout(timer.current);
        timer.current = setTimeout(handleTimeOut, 1000);
    }, [actStatus]);

    return <div></div>;
};

export default CountDown;
